import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'SourceChannel/Complete', method: 'GET', body: null, token: token })
}
